<template>
  <section class="wrapper issue-list">
    <div class="issue-list-left">
      <div class="glitches-circle-container">
        <span class="glitches-top-line"></span>
        <div class="glitches-title">CAPACITY</div>
        <div class="glitches-circle-box">
          <div class="glitches-circle">
            <canvas width="70" height="70" id="glitches-canvas-box">sorry,your browser doesn't support canvas</canvas>
          </div>
          <span class="glitches-num">{{ userQuota.quota }} / {{ userQuota.quotas }}</span>
        </div>
      </div>
      <div class="second-list">
        <div class="question-hide-btn-box">
          <transition name="slide">
            <span @click="hideEmpty" v-if="eyeClass==='close'" key="close" class="question-hide-btn">
              <ct-icon class="slide-item" style="font-size: 14px;" name="eye-close"></ct-icon>
              Chapter without question collection
            </span>
            <span @click="hideEmpty" v-else key="open" class="question-hide-btn">
              <ct-icon class="slide-item" style="font-size: 14px;" name="eye-open"></ct-icon>
              Chapter without question collection
            </span>
          </transition>
        </div>
        <div class="question-list-detail">
          <div>
            <div
              v-for="list in secondList"
              :key="list.id"
              v-show="list.visible"
              class="list-complete-item"
              @click="changeVisible(list)">
              <div :class="{'has-list': list.num}">
                {{ list.text }}
                <span class="issus-num-box" v-if="list.num">{{ list.num }}</span>
              </div>
              <el-collapse-transition>
                <div v-if="list.nodes" v-show="list.ownVisible">
                  <div
                    v-for="(item, index) in list.nodes"
                    :key="item.id"
                    v-show="item.visible"
                    class="list-complete-item second-item"
                    @click.stop="clickSecond(item)"
                    :class="{
                      'no-border': index === secondList.length - 1,
                      'active': currentActive === item.id
                    }">
                    <div :class="{'has-list': item.num}">
                      {{ item.text }}
                      <transition name="fade">
                        <span class="activeSymbol" v-if="currentActive===item.id"></span>
                      </transition>
                      <span class="issus-num-box" v-if="item.num">{{ item.num }}</span>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="horizon-hr"></div>
    <issue-list-sub
      class="issue-list-right"
      :id="currentItem.id"
      v-if="currentItem"
      @hasDelete="hasDelete"
    />
  </section>
</template>

<script>
import drawCircle from '@/utils/circle.js'
import IssueListSub from './sub/issueListSub.vue'
import { mapActions, mapGetters } from 'vuex'
import api from '../../api'
import storage from '@/utils/storage'
import storageKey from '@ca/constants/storageKey'

export default {
  name: 'IssueList',
  components: {
    'issue-list-sub': IssueListSub
  },
  data () {
    return {
      eyeClass: 'close',
      secondList: [],
      hideDown: true,
      currentActive: undefined,
      renderDown: true,
      userQuota: {
        quota: 0,
        quotas: 50
      }
    }
  },
  methods: {
    ...mapActions(['getSkillTree']),
    hasDelete () {
      this.init()
    },
    hideEmpty () {
      if (!this.hideDown) return
      this.hideDown = false
      let a = JSON.parse(JSON.stringify(this.secondList))
      a.forEach(el => {
        if (el.num === 0) {
          el.visible = !el.visible
        }
        if (el.nodes) {
          el.nodes.forEach(node => {
            if (node.num === 0) {
              node.visible = !el.visible
            }
          })
        }
      })
      this.secondList = a
      this.eyeClass = this.eyeClass === 'close' ? 'open' : 'close'
      setTimeout(() => {
        this.hideDown = true
      }, 500)
    },
    clickSecond (item) {
      if (!this.renderDown) return
      this.renderDown = false
      storage.set(storageKey.ISSUE_LIST_BREAK_POINT, item.id)
      setTimeout(() => {
        this.currentActive = item.id
        this.$nextTick(() => {
          this.renderDown = true
        })
      }, 200)
    },
    fomatData (arr) {
      let a = JSON.parse(JSON.stringify(arr))
      a.forEach(el => {
        el.visible = true
        if (el.nodes) {
          el.ownVisible = true
          el.nodes.forEach(node => {
            node.visible = true
          })
        }
      })
      return a
    },
    init () {
      api.getSkillTreeWrongCount().then(res => {
        let data = res.data
        if (data.code === 1) {
          data = data.data || {}
          let a = JSON.parse(JSON.stringify(this.secondList))
          a.forEach((ell) => {
            if (ell.nodes) {
              ell.nodes.forEach(el => {
                el.num = data[el.id - 0] || 0
              })
            }
          })
          this.secondList = a
        }
      }, err => {
        this.$toast({
          message: err
        })
      })
      api.getWrongQuota().then(res => {
        let data = res.data
        if (data.code === 1) {
          data = data.data
          this.userQuota = {
            quota: data.num,
            quotas: data.total_num
          }
        } else {
          this.userQuota = {
            quota: 0,
            quotas: 50
          }
        }
      }, err => {
        this.$toast({
          message: err
        })
        this.userQuota = {
          quota: 0,
          quotas: 50
        }
      })
    },
    changeVisible (item) {
      if (this.visChangeDown) return
      this.visChangeDown = false
      let id = this.activeID === item.id ? -1 : item.id
      this.activeID = id
      this.currentActive = ''
      const a = JSON.parse(JSON.stringify(this.secondList))
      a.forEach(el => {
        el.visible = true
        el.ownVisible = el.id === id
        if (el.id === id && el.nodes) {
          this.currentActive = el.nodes[0].id
          el.nodes.forEach(node => {
            node.visible = true
          })
        }
      })
      this.secondList = a
      setTimeout(() => {
        this.visChangeDown = false
      }, 200)
    },
    getActiveId () {
      let id = ''
      let isFirst = false
      this.skillTree.forEach(el => {
        if (el.nodes && !isFirst) {
          isFirst = true
          el.ownVisible = true
          this.activeID = el.id
          id = el.nodes[0].id
        }
      })
      return id
    }
  },
  watch: {
    userQuota (val) {
      const a = document.getElementById('glitches-canvas-box')
      const ctx = a.getContext('2d')
      ctx.clearRect(0, 0, 70, 70)
      drawCircle(ctx, val.quota, val.quotas, 35, 35, 4, 29, 'rgba(55, 202, 215, 1)', 400)
    }
  },
  computed: {
    ...mapGetters(['skillTree']),
    currentItem () {
      let temp = {}
      this.skillTree.forEach(el => {
        if (el.nodes) {
          el.nodes.forEach(node => {
            if (node.id === this.currentActive) {
              temp = node
            }
          })
        }
      })
      return temp
    }
  },
  mounted () {
    this.$store.dispatch('getSkillTree').then(res => {
      this.secondList = this.fomatData(this.skillTree)
      let a = (storage.get(storageKey.ISSUE_LIST_BREAK_POINT) - 0)
      if (!a) {
        a = this.getActiveId()
      }
      this.currentActive = a
      this.$nextTick(el => {
        this.init()
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.issue-list {
  margin-top: 17px;
  margin-bottom: 40px;
  box-shadow: 0px 2px 12px 0px rgba(79, 117, 162, 0.07);
  border-radius: 2px;
  position: relative;

  &:before,
  &:after {
    content: " ";
    display: table;
  }

  &:after {
    clear: both;
  }

  .issue-list-left {
    float: left;
    width: 310px;
    margin-bottom: 40px;
    overflow: hidden;

    .glitches-circle-container {
      background: rgba(247, 251, 255, 1);
      position: relative;
      text-align: center;
      padding-bottom: 18px;

      .glitches-top-line {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(135deg, rgba(48, 186, 199, 1) 0%, rgba(55, 202, 215, 1) 100%);
      }

      .glitches-title {
        padding: 18px 0 14px;
        text-align: center;
        font-size: 13px;
        font-weight: 500;
        color: rgba(26, 61, 94, 1);
        line-height: 15px;
      }

      .glitches-circle-box {
        position: relative;

        .glitches-circle {
          border-radius: 50%;
          width: 60px;
          height: 60px;
          border: 3px solid rgba(26, 61, 94, .04);
          margin: 0 auto;

          #glitches-canvas-box {
            position: relative;
            left: -8px;
            top: -8px;
            z-index: 1;
          }
        }

        .glitches-num {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          font-size: 12px;
          color: rgba(26, 61, 94, 0.3);
          line-height: 12px;
        }
      }
    }

    .second-list {
      .question-hide-btn-box {
        margin: 16px 0;
        font-size: 13px;
        color: rgba(26, 61, 94, 1);
        line-height: 13px;
        height: 13px;
        position: relative;
        padding-left: 16px;

        .question-hide-btn {
          cursor: pointer;

          &:hover {
            color: #37CAD7;
          }
        }

        // animation
        .slide-leave-active, .slide-enter-active {
          transition: all .5s ease;
          left: 16px;
          top: 0;
          position: absolute;
        }

        .slide-enter
          /* .slide-fade-leave-active for below version 2.1.8 */
        {
          transform: translateX(100px);
          opacity: 0;
        }

        .slide-leave-to {
          transform: translateX(-100px);
          opacity: 0;
        }
      }

      .question-list-detail {
        position: relative;
        overflow: hidden;
        // .list-complete-move {
        //   transition: transform .3s;
        // }
        .list-complete-enter,
        .list-complete-leave-to {
          opacity: 0;
          transform: translateX(-50px);
        }

        .list-complete-enter-active,
        .list-complete-leave-active {
          position: absolute;
          width: 100%;
        }

        .list-complete-item {
          font-size: 14px;
          color: rgba(118, 139, 158, 1);
          //padding-left: 16px;
          cursor: pointer;
          position: relative;
          transition: all .25s;
          box-shadow: 0 0 0 0 rgba(35, 62, 114, 0.07);

          > div {
            padding: 11px 0;
            line-height: 22px;
            border-bottom: 1px solid rgba(239, 244, 250, 1);

            &:first-child {
              margin-left: 16px;
            }

            &.has-list {
              padding-right: 50px;
            }

          }

          &.no-border {
            > div {
              border: none;
            }
          }

          &:hover {
            color: rgba(26, 61, 94, 1);
            font-weight: 500;
            box-shadow: 0px 2px 16px 0px rgba(35, 62, 114, 0.07);
          }

          &.active {
            color: rgba(26, 61, 94, 1);
            font-weight: 500;
          }

          .activeSymbol {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 21px;
            background: linear-gradient(135deg, rgba(48, 186, 199, 1) 0%, rgba(55, 202, 215, 1) 100%);
            border-radius: 1px;
          }

          .fade-enter-active, .fade-leave-active {
            transition: opacity .1s;
          }

          .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
          {
            opacity: 0;
          }

          .issus-num-box {
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: rgba(26, 61, 94, .06);
            font-size: 12px;
            font-weight: 500;
            color: rgba(26, 61, 94, 1);
            line-height: 20px;
            text-align: center;
          }

          &.second-item {
            padding-left: 16px;
          }
        }
      }
    }
  }

  .horizon-hr {
    position: absolute;
    width: 1px;
    height: 100%;
    top: 0;
    left: 310px;
    background: rgba(239, 244, 250, 1);
  }

  .issue-list-right {
    margin-left: 310px;
  }
}
</style>
